import { FC, useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export const ThemeToggle: FC = () => {
  const [theme, setTheme] = useState<"light" | "dark">(
    (localStorage.getItem("theme") as "light" | "dark") || "light"
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-full border border-[#B3B3B3] w-10 h-10 flex items-center justify-center hover:bg-[#EDEDED] transition"
      aria-label="Toggle Theme"
      data-testid="theme-toggle"
    >
      {theme === "light" ? (
        <Sun size={22} className="text-[#F4763C]" />
      ) : (
        <Moon size={22} className="text-[#FA9260]" />
      )}
    </button>
  );
};

export default ThemeToggle;